import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material';
@Component({
  selector: 'app-car-charger-bottom-sheet',
  templateUrl: './car-charger-bottom-sheet.component.html',
  styleUrls: ['./car-charger-bottom-sheet.component.scss']
})
export class CarChargerBottomSheetComponent implements OnInit {

  constructor(private bottomSheetRef:MatBottomSheetRef<CarChargerBottomSheetComponent>) { }

  ngOnInit() {
  }
 close ():void{
  this.bottomSheetRef.dismiss();
 }
}
